export const SET_PROPERTIES = 'SET_PROPERTIES';
